<template>
  <div class="pluspages-message">
    <header>
      <Tab
        isBlueLine
        :selected="tabsValue"
        :tabList="tabList"
        backgroundColor="#fff"
        titleActiveColor="#3378FF"
        titleInactiveColor="#7A8699"
        :handleChange="handleChange"
      ></Tab>
    </header>
    <main>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="card" v-for="messages in tableData" :key="messages.id">
            <div class="visual">
              <div class="left">
                <van-icon name="bullhorn-o" />
              </div>
              <div class="right">
                <div class="top">
                  <span v-if="tabsValue === 1">电票推送</span>
                  <span v-else>发票开具</span>
                  <div class="btn-list">
                    <div class="btn">
                      <!-- <MainButton
                        size="auto"
                        :handleClick="handleGetInvoiceInfo"
                      >
                        <span>查看详情</span>
                      </MainButton> -->
                    </div>
                  </div>
                </div>
                <div class="message">
                  <div class="text-hide">
                    {{ messages.notificationList[0].content }}
                  </div>
                </div>
              </div>
            </div>
            <MoreData :defaultOpen="false" textAlign="right">
              <div class="hide-data">
                <van-steps direction="vertical" active-icon="success" active-color="#38f" :active="0">
                  <van-step v-for="(msg, index) in messages.notificationList" :key="index">
                    <h3>{{ msg.content }}</h3>
                    <p>{{ msg.readTime }}</p>
                  </van-step>
                </van-steps>
              </div>
            </MoreData>
          </div>
        </van-list>
      </van-pull-refresh>
    </main>
  </div>
</template>

<script>
import Tab from '@/components/Tab/index.vue'
import Observer from '@utils/observer'
import MoreData from '@/components/MoreData/index.vue'
import { Step, Steps, PullRefresh, List, Icon } from 'vant'
import { mapActions, mapState, mapMutations } from 'vuex'
// import MainButton from '@/components/MainButton/index.vue'
export default {
  components: {
    Tab,
    // MainButton,
    MoreData,
    [Step.name]: Step,
    [List.name]: List,
    [Icon.name]: Icon,
    [Steps.name]: Steps,
    [PullRefresh.name]: PullRefresh
  },
  computed: {
    ...mapState('messageModel', ['tableData', 'query', 'total'])
  },
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      selectedItemId: '',
      tabList: [
        {
          title: '发票开具',
          index: 2
        }, {
          title: '电票推送',
          index: 1
        }
      ],
      tabsValue: 2
    }
  },

  async mounted () {
    await this.setTableData([])
    this.onRefresh()
    Observer.setFunction({
      type: 'changeCompany',
      fn: this.companyChangeRefresh
    })
  },

  methods: {
    ...mapMutations('messageModel', ['setTableData', 'setQuery']),
    ...mapActions('messageModel', ['getTableData']),
    async handleChange (code) {
      if (code === this.tabsValue) return
      this.tabsValue = code
      await this.setTableData([])
      this.onRefresh()
    },
    handleGetInvoiceInfo () {

    },
    async onLoad () {
      if (this.refreshing) {
        await this.setTableData([])
        this.refreshing = false
      }
      await this.setQuery({ field: 'current', value: Number(this.query.current) + 1 })
      // 重置查询条件
      await this.getTableData(this.tabsValue)
      this.loading = false
      if (this.tableData.length >= Number(this.total)) {
        this.finished = true
      }
    },
    async onRefresh () {
      await this.setQuery({ field: 'current', value: 0 })
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    async companyChangeRefresh () {
      if (window.location.pathname + window.location.search === '/small-bell/message') {
        await this.setTableData([])
        this.onRefresh()
      }
    }
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
